import BoolCell from '../cells/bool';

// eslint-disable-next-line react/display-name
export const booleanBodyRender = () => (value: boolean | null | undefined) => {
  return <><BoolCell value={value} /></>;
};
